"use client"

import { motion } from "framer-motion"
import { Clock, TrendingUp, MessageCircle } from "lucide-react"

export function BenefitsSection() {
  const benefits = [
    {
      icon: Clock,
      title: "Время для развития бизнеса",
      description:
        "Вместо копирования одинаковых ответов про размеры и доставку, вы создаете новый контент, работаете с поставщиками, развиваете продуктовую линейку.",
      metric: "Экономия 3+ часов ежедневно (21 час в неделю)",
    },
    {
      icon: TrendingUp,
      title: "Ни одна продажа не потеряна",
      description: 'Клиенты получают мгновенные ответы 24/7. Больше никаких "уже купила в другом месте".',
      metric: "Увеличение conversion rate на 30-40%",
    },
    {
      icon: MessageCircle,
      title: "Ваш brand voice сохранен",
      description: "Каждое сообщение звучит так, как будто это написали именно вы.",
      metric: "92% клиентов не замечают разницы",
    },
  ]

  return (
    <section id="benefits" className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="font-serif text-4xl md:text-5xl lg:text-6xl text-center mb-6 leading-tight text-balance"
        >
          Представьте, что вы освободили <span className="text-accent">21 час в неделю</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-center text-lg text-muted-foreground max-w-3xl mx-auto mb-16"
        >
          От 4 часов ежедневной рутины в DM к 45 минутам осознанной работы с действительно важными клиентами.
        </motion.p>

        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-secondary rounded-3xl p-8 border border-border hover:border-accent/50 transition-colors"
            >
              <benefit.icon className="w-12 h-12 text-accent mb-6" />
              <h3 className="font-serif text-2xl font-semibold mb-4">{benefit.title}</h3>
              <p className="text-muted-foreground leading-relaxed mb-4">{benefit.description}</p>
              <div className="text-sm font-semibold text-accent">{benefit.metric}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
